import React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

type BreadcrumbItem = { href: string; title: string };
type BreadcrumbList = BreadcrumbItem[];

const BreadcrumbNav = (props: { breadcrumbList: BreadcrumbList }) => {
  const { breadcrumbList } = props;
  const breadcrumbs = breadcrumbList.map(({ href, title }, index) => {
    if (index !== breadcrumbList.length - 1) {
      return (
        <Link
          underline="hover"
          key={index}
          href={href}
          className="!text-black leading-none hover:underline"
        >
          {title}
        </Link>
      );
    }
    return (
      <Typography
        key={index}
        component="span"
        className="text-web-grey-600 leading-none"
      >
        {title}
      </Typography>
    );
  });
  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
    >
      {breadcrumbs}
    </Breadcrumbs>
  );
};

export default BreadcrumbNav;
